export const NOTES_INPUT_MAXLENGTH = 100;
export const TRAVEL_INPUT_MAXLENGTH = 1000;
